import SectionCard from './Components/SectionCard';

export default SectionCard;
